(function ($) {




    function getIOSInfo() {
        const ua = navigator.userAgent || '';
        const platform = navigator.platform || '';
        const maxTouchPoints = navigator.maxTouchPoints || 0;

        const isIPhone = /iPhone/.test(ua);
        const isIPod = /iPod/.test(ua);
        const isIPad = /iPad/.test(ua);

        // iPadOS can present itself more like Mac, so this catches that case
        const isIPadOS = platform === 'MacIntel' && maxTouchPoints > 1;

        const isIOS = isIPhone || isIPod || isIPad || isIPadOS;

        return {
            isIOS,
            isIPhone,
            isIPod,
            isIPad: isIPad || isIPadOS,
            isIPadOS,
        };
    }




    function getScrollbarWidth() {
        // Create a temporary outer container
        const outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.position = 'absolute';
        outer.style.top = '-9999px';
        outer.style.width = '100px';
        outer.style.height = '100px';
        outer.style.overflow = 'scroll'; // force scrollbars
        outer.style.msOverflowStyle = 'scrollbar'; // legacy IE/Edge

        document.body.appendChild(outer);

        // Create inner element and measure the difference
        const inner = document.createElement('div');
        inner.style.width = '100%';
        inner.style.height = '100%';
        outer.appendChild(inner);

        const scrollbarWidth = outer.offsetWidth - outer.clientWidth;

        outer.remove();
        return scrollbarWidth;
    }


    function getModalOverlayEl($modalEl) {
        if (!$modalEl.length) return ;

        const modalId = $modalEl.attr('id').trim();
        return $(`#modal-overlay-${modalId}`);
    }



    function getModalContentEl($modalEl) {
        if (!$modalEl.length) return ;

        return $modalEl.find('.c-modal__content');
    }



    function getModalOpenButtonEl($modalEl) {
        if (!$modalEl.length) return ;

        const modalId = $modalEl.attr('id').trim();
        return $(`[data-open-c-modal="${modalId}"]`);
    }



    function getModalCloseIconButtonEl($modalEl) {
        if (!$modalEl.length) return ;

        return $modalEl.find('.c-modal__close-btn');
    }



    function preparePlayIframeYouTubeVideo($iframeEl) {
        if (!($iframeEl && $iframeEl.length > 0)) {
            return;
        }

        const iframeSrc = $iframeEl.attr('src');

        if (!iframeSrc || !iframeSrc.includes('youtube.com/embed')) {
            return;
        }


        const iosInfoRes = getIOSInfo();
        const isIOS = iosInfoRes.isIOS;

        // for Safari on iOS 18 or less - autoplay approach works inconsistently so leave it as is on those iOS versions
        const url = new URL(iframeSrc);

        url.searchParams.set('autoplay', '1');
        url.searchParams.set('playsinline', '1');

        // if not mute - ios browsers will nt allow autoplay
        if (isIOS) {
            url.searchParams.set('mute', '1');
        }


        const nextSrc = url.toString();

        $iframeEl.attr('allow', 'autoplay; encrypted-media; picture-in-picture');
        $iframeEl.attr('referrerpolicy', 'strict-origin-when-cross-origin');

        if (iframeSrc !== nextSrc) {
            $iframeEl.attr('src', nextSrc);
        }
    }



    function openModal($modal) {
        if (!($modal.length)) return;

        const $modalOverlay = getModalOverlayEl($modal);
        const $modalContent = getModalContentEl($modal);

        if ($modalContent.data('c-modal-iframe') && $modalContent.children().length === 0) {
            const $iframeEl = $( $modalContent.data('c-modal-iframe') );

            // if we created an actual iframe
            if ($iframeEl.is('iframe')) {
                preparePlayIframeYouTubeVideo($iframeEl);
                $modalContent.html('').append( $iframeEl );
            }
        }

        const $videoEl = $modalContent.find('video');
        if ($videoEl.length > 0){
            $videoEl.each(function () {
                this.play();
            });
        }

        $modal.attr({
                'aria-hidden': false
            }).show();


        $modalOverlay.attr({
            'aria-hidden': false
        }).show();



        $('html, body').addClass('c-modal-opened');


        const $modalOpenButton = getModalOpenButtonEl($modal);
        $modalOpenButton.trigger('blur');

        const $modalCloseButton = getModalCloseIconButtonEl($modal);
        $modalCloseButton.trigger('focus');
    }



    function closeModal($modal) {
        if (!($modal.length && $modal.length)) return;

        const $modalOverlay = getModalOverlayEl($modal);
        const $modalOpenButton = getModalOpenButtonEl($modal);
        const $modalContent = getModalContentEl($modal);

        // removing iframe on close so we stop plying video always for sure
        if ($modalContent.data('c-modal-iframe')) {
            $modalContent.html('');
        }

        const $videoAudioEl = $modalContent.find('video, audio');
        if ($videoAudioEl.length > 0){
            $videoAudioEl.each(function () {
                this.pause();
                this.currentTime = 0; // optional
            });
        }

        $modal.attr({
            'aria-hidden': true
        })
            .hide();

        $modalOverlay.attr({
            'aria-hidden': true
        })
            .hide();



        $('html, body').removeClass('c-modal-opened');



        $modalOpenButton.focus();
    }


    $(document).on('ready', function () {


        // ============= closing modal =============
        $(document).on('keydown', function (e) {
            const isEsc = (e.key === 'Escape' || e.key === 'Esc' || e.which === 27);

            if (!isEsc) return;

            const $currentlyOpenedModals = $('.c-modal:visible');
            if ($currentlyOpenedModals.length) {
                closeModal($currentlyOpenedModals.last());
            }
        });
        // ============= closing modal =============


        const $body = $('body');

        $body.prepend(`<style>:root { --c-scrollbar-width: ${ getScrollbarWidth() }px; }</style>`);


        // ======= checking if we occasionally got modals with same ids
        const modalsIdsCount = {};
        const $modals = $('.c-modal');

        $modals.map(function () {
            const curModalId = $(this).attr('id').trim();

            if (!modalsIdsCount.hasOwnProperty(curModalId)) {
                modalsIdsCount[curModalId] = 0;
            }

            modalsIdsCount[curModalId] += 1;
        });

        for (const modalIdKey in modalsIdsCount) {
            if (modalsIdsCount[ modalIdKey ] > 1) {
                const message = `There are ${modalsIdsCount[ modalIdKey ]} modals with id = ${modalIdKey}. \n\nAll modals need to have unique id to work correctly.`;

                // for logged-in users -s displaying an alert()
                if ($body.hasClass('logged-in')) {
                    alert(message);
                }
                // for non-logged-in users -s displaying a warning in console
                else {
                    console.warn(message);
                }
                break;
            }
        }
        // ======= checking if we occasionally got modals with same ids




        $modals.each(function () {

            const $thisModal = $(this);
            const modalId = $thisModal.attr('id');

            const $thisModalOverlay = getModalOverlayEl($thisModal);

            const $openButton = getModalOpenButtonEl($thisModal);
            const $closeButton = $(`[data-close-c-modal="${modalId}"]`);

            $thisModalOverlay.appendTo( $body );
            $thisModal.appendTo( $body );



            // ============= opening modal =============
            $openButton.on('click', function (e) {
                 e.preventDefault();

                openModal($thisModal);
            });
            // ============= opening modal =============



            // ============= closing modal =============
            $closeButton.on('click', function (e) {
                e.preventDefault();

                closeModal($thisModal);
            });
            // ============= closing modal =============

        });

    });


})(jQuery);